export default __webpack_public_path__ + "static/media/ic_chat.8f38e819.svg";